import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import React from "react";
import DefaultAvatar from "../../../assets/icons/default-avatar.svg";
import "../Profile.scss";


const UserProfilePopup = ({
  openModal,
  anchorEl,
  userDetails,
  placement,
  isDashboard,
  isCollaborators,
  extraClass,
}) => {
  return (
    <Popper
      open={openModal}
      anchorEl={anchorEl}
      placement={placement}
      transition
      className={extraClass ? extraClass : "popper-styling"}
      sx={isCollaborators ? { zIndex: 9999 } : {}}
    >
      <Paper
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "150px",
          alignItems: "center",
          justifyContent: "center",
          width: "380px",
          boxShadow: "0px 2px 10px #999999",
        }}
      >
        <img
          src={
            userDetails.userImageSrc !== null && userDetails.userImageSrc !== ""
              ? userDetails.userImageSrc
              : DefaultAvatar
          }
          style={{ height: 125, width: 125 }}
        />
        <List>
          <ListItem sx={{ fontWeight: "bolder", fontSize: "large" }}>
            {userDetails.firstName} {userDetails.lastName}
          </ListItem>
          <ListItem sx={{ textTransform: "capitalize" }}>
            {userDetails.roleName}
          </ListItem>
          <ListItem sx={{ paddingTop: 0 }}>
            {userDetails.userEmail}
          </ListItem>
        </List>
      </Paper>
    </Popper>
  );
};

export default UserProfilePopup;
